import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Loader2, Database } from 'lucide-react';
import { runCompleteSeriesBackfill } from '@/utils/backfillSeriesData';
import { toast } from 'sonner';

export function SeriesBackfillButton() {
  const [loading, setLoading] = useState(false);

  const handleBackfill = async () => {
    setLoading(true);
    try {
      const results = await runCompleteSeriesBackfill();
      toast.success(`Backfill complete! ${results.booksUpdated} books updated, ${results.seriesTracked} series tracked`);
    } catch (error) {
      console.error('Backfill error:', error);
      toast.error('Failed to backfill series data');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      onClick={handleBackfill}
      disabled={loading}
      variant="outline"
      size="sm"
    >
      {loading ? (
        <>
          <Loader2 className="h-4 w-4 mr-2 animate-spin" />
          Processing...
        </>
      ) : (
        <>
          <Database className="h-4 w-4 mr-2" />
          Detect Series Data
        </>
      )}
    </Button>
  );
}
